// eslint-disable-next-line import/no-cycle
import request from '@/utils/request'

/* 首页 - 我的待办 列表 */
export function getIndexTodoList(data) {
  return request({
    url: '/admin/v1/vehicle/affairs/index',
    method: 'POST',
    data,
  })
}

/* 首页 - 我的待办 数目 */
export function getIndexTodoCount(data) {
  return request({
    url: '/admin/v1/vehicle/affairs/count',
    method: 'POST',
    data,
  })
}

/* 待办中心 - 待办列表（已处理、未处理） */
export function getCenterTodoList(data) {
  return request({
    url: '/admin/v1/vehicle/affairs/getDealWithList',
    method: 'POST',
    data,
  })
}

/* 待办管理 - 列表 */
export function getConfigTodoList(data) {
  return request({
    url: '/admin/v1/vehicle/affairs/config/list',
    method: 'POST',
    data,
  })
}


/* 待办管理 创建 */
export function addConfigTodo(data) {
  return request({
    url: '/admin/v1/vehicle/affairs/config/add',
    method: 'POST',
    data,
  })
}

/* 待办管理 更新 */
export function updateConfigTodo(data) {
  return request({
    url: '/admin/v1/vehicle/affairs/config/update',
    method: 'POST',
    data,
  })
}

/* 待办管理 详情 */
export function configTodoDetail(data) {
  return request({
    url: '/admin/v1/vehicle/affairs/config/detail',
    method: 'POST',
    data,
  })
}

/* 待办管理 启用、禁用 */
export function configTodoSwitchStatus(data) {
  return request({
    url: '/admin/v1/vehicle/affairs/config/switchStatus',
    method: 'POST',
    data,
  })
}

